import { QueryClient } from '@tanstack/react-query';

const isServerError = (error: unknown) => {
    const code = (error as { status?: number } | null)?.status ?? 0;
    return code >= 400;
};

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: (failureCount, error) => {
                if (isServerError(error)) return false;
                return failureCount < 3;
            },
            refetchOnWindowFocus: false,
        },
    },
});
